import { render, staticRenderFns } from "./workflow_canvas_brick_ghost.vue?vue&type=template&id=8f026e8a&scoped=true&"
import script from "./workflow_canvas_brick_ghost.vue?vue&type=script&lang=js&"
export * from "./workflow_canvas_brick_ghost.vue?vue&type=script&lang=js&"
import style0 from "./workflow_canvas_brick_ghost.vue?vue&type=style&index=0&id=8f026e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f026e8a",
  null
  
)

export default component.exports